import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataService } from './data.service';
 
@Injectable()
export class AuthGuard implements CanActivate {
 
    constructor(private router: Router, private dataService: DataService) { }
 
    canActivate():boolean {
        if (this.dataService.tmpCto > 10000000000) {            
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login']);
        return false;
    }
}